import { PermissionsEnum } from '@/auth/interfaces';
import { SavePresentacion } from '../../shared/savePresentaciones';
import { useCheckPermissions } from '@/shared';

export interface CreatePresentacionesPageInterface {}

const CreatePresentacionesPage: React.FC<CreatePresentacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_presentacion)
  return <SavePresentacion titlePage="Crear Presentaciones" />;
};

export default CreatePresentacionesPage;
